"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dropdown = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _utils = require("../../utils");
var _NativeDropdown = require("./NativeDropdown");
var _CustomDropdown = require("./CustomDropdown");
var _Option = require("./Option");
var _excluded = ["children", "id", "onBlur", "onChange", "placeholder", "value"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var Dropdown = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
    id = _ref.id,
    _ref$onBlur = _ref.onBlur,
    onBlur = _ref$onBlur === void 0 ? _lodash.noop : _ref$onBlur,
    onChange = _ref.onChange,
    placeholder = _ref.placeholder,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    props = _objectWithoutProperties(_ref, _excluded);
  value = value === null ? '' : value;

  // Ensure children is a flat array
  var childArray = (0, _react.useMemo)(function () {
    var allChildren = _react.default.Children.toArray(children);
    return (0, _lodash.compact)([placeholder && /*#__PURE__*/_react.default.createElement(_Option.Option, {
      value: "",
      key: placeholder
    }, placeholder)].concat(_toConsumableArray(allChildren)));
  }, [children, placeholder]);
  var _useInputValidation = (0, _utils.useInputValidation)(props),
    error = _useInputValidation.error,
    validateOnBlur = _useInputValidation.validateOnBlur;
  var handleBlur = function handleBlur(e) {
    validateOnBlur();
    onBlur(e);
  };
  (0, _react.useEffect)(function () {
    if (!value) {
      // Mimic native behavior where first option is automatically selected
      // if a falsy value is provided and no option with a falsy value exists
      var childWithFalsyValue = childArray.find(function (child) {
        return child.props.value === value;
      });
      if (!childWithFalsyValue) {
        onChange(childArray[0].props.value);
      }
    }
  }, [value]);
  if ((0, _utils.isMobile)()) {
    return /*#__PURE__*/_react.default.createElement(_NativeDropdown.NativeDropdown, _extends({
      children: childArray,
      id: id,
      error: error,
      onBlur: handleBlur,
      onChange: onChange,
      ref: ref,
      value: value
    }, props));
  }
  return /*#__PURE__*/_react.default.createElement(_CustomDropdown.CustomDropdown, _extends({
    children: childArray,
    id: id,
    error: error,
    onBlur: handleBlur,
    onChange: onChange,
    ref: ref,
    value: value
  }, props));
});
var DropdownNamespace = Object.assign(Dropdown, {
  Option: _Option.Option
});
exports.Dropdown = DropdownNamespace;